import { Directive } from '@angular/core';

@Directive({
    selector: '[ndtCenterColumn]',
    host: { class: 'center-column' },
    standalone: false
})
export class CenterColumnDirective {}
